module.exports = __webpack_public_path__ + "static/letter-envelop-a2a692f55d5b64a8df5af88f0eed7f35.png";